module.exports = __webpack_public_path__ + "media/images/beach-2-12c98184.jpg";